import React from 'react';
import { Box } from '@mui/material';

interface IProps {
  onOpen: (anchor: HTMLElement) => void;
  children: React.ReactNode;
}

export const CellTrigger: React.FC<IProps> = ({ onOpen, children }) => (
  <Box component="span" sx={{ cursor: 'pointer' }} onClick={(event: React.MouseEvent<HTMLElement>) => onOpen(event.currentTarget)}>
    {children}
  </Box>
);
